import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  setGroupsAreLoading,
  setSelectedModule,
  setSelectedModuleIsOpen,
  copyAssumptionGroup,
} from '../../../store/actions';
import { postWithToken, getWithToken } from 'api/network';

export function* copyAssumptionGroupSaga() {
  yield takeEvery(copyAssumptionGroup, function* ({ payload }) {
    try {

      yield put(setGroupsAreLoading(true));

      const url = `/api/assumptions/copyAssumptionGroup/${payload.groupId}`
      yield postWithToken(url)

      yield put(setGroupsAreLoading(true));

      const getGroupUrl = `/api/assumptions/modules/${payload.selectedModuleId}`;
      const res = yield getWithToken(getGroupUrl);
      const data = yield res.json();

      yield put(setSelectedModule(data));
      yield put(setSelectedModuleIsOpen(true));
      yield put(setGroupsAreLoading(false));

      yield put(appNotify(`copy successful`, 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to copy assumption group: ${error}`, 'error')
      );

      yield put(setGroupsAreLoading(false));
    }
  });
}
